// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__PPx5j","buttons":"PendingPaymentAlert_buttons__1kCnG"};